import { useTranslation } from 'react-i18next';

import { Button, Text } from '@fly/core';
import { routes } from '@fly/shared';
import { FlyEmptyState } from '@fly/shared-ui';

export function TokenManagementTableEmptyState() {
  const { t } = useTranslation();

  const noDataFound = t('app.dashboard.messages.info.no_data_found', {
    defaultValue: 'No data found',
  });
  return (
    <FlyEmptyState title={noDataFound}>
      <div className='flex flex-col items-center justify-center gap-fly-6'>
        <Text size='2' highContrast>
          {t('app.dashboard.token_management.messages.get_started', {
            defaultValue: 'Get started by Generating a Token',
          })}
        </Text>
        <Button
          variant='solid'
          size='2'
          to={routes.DASHBOARD.ACCOUNT.TOKEN_GENERATE}
          iconStart='plus'
        >
          {t('app.dashboard.header.user_menu.workspace.buttons.generate_token')}
        </Button>
      </div>
    </FlyEmptyState>
  );
}
